module.exports = __webpack_public_path__ + "img/key-icon-white.df8a78ab.svg";